import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroNameSelector from "TaskDialogCommon/HeroNameSelector";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import BossSelector from "TaskDialogCommon/BossSelector";
import { getLastConfigForTask } from "Utils/Common";
import { getStyleJSON } from "Utils/Common";

const taskname = "ebkv2run";

const normalbosses = [
  "20",
  "30",
  "40",
  "50",
  "60",
  "70",
  "80",
  "90",
  "100",
  "110",
  "250",
  "210",
  "200",
];

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        // Elite bosses kill config
        killelitebosses: false,
        selectedeliteAlliBoss: {},
        mithhitelite: 0,

        // normal bosses kill config
        killnormalbosses: false,
        selectednormalAlliBoss: "250",
        mithhitnormal: 0,

        // common attack hero for both elite and normal
        // boss killing
        atkheroname: "",
        troopskiller: {},
        popatkrunesformins: 0,

        // Elite boss summon config
        summonelitebosses: false,
        useestams: 999,

        // Normal boss summon config
        summonnormalbosses: false,
        usestams: 999,

        // common hero for both elite and normal boss
        // summoning
        troopssummoner: {},
        defheroname: "",

        killonlymybosses: false,

        unboxtroops: true,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      if (storeddata) {
        // Elite bosses kill config
        taskConfig.killelitebosses = storeddata.killelitebosses;
        for (var key in accountdetail.allielitebosses) {
          var elitebossObj = accountdetail.allielitebosses[key];
          if (elitebossObj.bossid === storeddata.selectedeliteAlliBoss.bossid) {
            taskConfig.selectedeliteAlliBoss = elitebossObj;
            break;
          }
        }

        taskConfig.mithhitelite = storeddata.mithhitelite;

        // normal bosses kill config
        taskConfig.killnormalbosses = storeddata.killnormalbosses;
        taskConfig.selectednormalAlliBoss = storeddata.selectednormalAlliBoss;
        taskConfig.mithhitnormal = storeddata.mithhitnormal;

        // common attack hero for both elite and
        // normal
        // boss killing

        for (var key in accountdetail.heroes) {
          var cityObj = accountdetail.heroes[key];
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.atkheroname) {
              taskConfig.atkheroname = storeddata.atkheroname;
            }
            if (heroObj.heroname === storeddata.defheroname) {
              taskConfig.defheroname = storeddata.defheroname;
            }
          }
        }

        taskConfig.troopskiller = { ...storeddata.troopskiller };
        taskConfig.popatkrunesformins = storeddata.popatkrunesformins;

        // Elite boss summon config
        taskConfig.summonelitebosses = storeddata.summonelitebosses;
        taskConfig.useestams = storeddata.useestams;

        // Normal boss summon config
        taskConfig.summonnormalbosses = storeddata.summonnormalbosses;
        taskConfig.usestams = storeddata.usestams;

        // common hero for both elite and normal
        // boss
        // summoning
        taskConfig.troopssummoner = { ...storeddata.troopssummoner };

        taskConfig.killonlymybosses = storeddata.killonlymybosses;
        taskConfig.unboxtroops = storeddata.unboxtroops;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;
    if (AccountDetailData.allielitebosses === undefined) {
      errordialog.showError(
        "Account does not seem to have access to Alliance Bosses. Please contact admin."
      );
      return null;
    }

    return (
      <TaskDialog heading={"EBK Run"}>
        {(taskConfig.killnormalbosses || taskConfig.killelitebosses) && (
          <div
            align="center"
            style={getStyleJSON("border: solid 1px;padding:20px")}
          >
            <HeroNameSelector
              label={"Select Bosskill Hero"}
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              param={"atkheroname"}
            />
            <TaskInput
              label={"Autopop full atk runes(Optional)"}
              value={taskConfig.popatkrunesformins}
              onChange={(event) => setValue(event, "popatkrunesformins")}
              instruction={`*Checks how much time you have full ATK runes popped
              for. If not popped or if popped less than mins entered
              here, it will pop the required. So if u enter 30 mins,
              it will pop full ATK runes to make sure you are
              covered for 30 mins IF they are not already popped.
              The runes ill be popped only while KILLING BOSS, not
              while summoning boss and will be popped EVERYTIME it
              tries to hit a boss so just entering 15 mins will
              ensure that before each boss hit full atk runes are
              popped once. Recommended value is 10 mins.`}
            />

            <TroopMapSelector
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              label={"Add Troops To Send for killing boss"}
              param={"troopskiller"}
            />
          </div>
        )}
        <div
          style={getStyleJSON("background-color: yellow; border: solid 1px;")}
        >
          <TaskCheckBox
            label={"Kill Elite Bosses."}
            param={"killelitebosses"}
            taskConfig={taskConfig}
            setValue={setValue}
          />
        </div>

        {taskConfig.killelitebosses && (
          <div style={{ border: "solid 1px;" }}>
            <BossSelector
              label={"Select elite boss to kill"}
              param={"selectedeliteAlliBoss"}
              taskConfig={taskConfig}
              setValue={setValue}
              bosslist={AccountDetailData.allielitebosses}
            />
            <TaskInput
              label={"No of mith hits to do(optional)"}
              value={taskConfig.mithhitelite}
              onChange={(event) => setValue(event, "mithhitelite")}
            />
          </div>
        )}
        <div
          style={getStyleJSON("background-color: yellow; border: solid 1px;")}
        >
          <TaskCheckBox
            label={"Kill Normal Bosses."}
            param={"killnormalbosses"}
            taskConfig={taskConfig}
            setValue={setValue}
          />
        </div>
        {taskConfig.killnormalbosses && (
          <div style={{ border: "solid 1px;" }}>
            <TaskInput
              label={"No of mith hits to do(optional)"}
              value={taskConfig.mithhitnormal}
              onChange={(event) => setValue(event, "mithhitnormal")}
            />
          </div>
        )}
        <div
          style={getStyleJSON("background-color: yellow; border: solid 1px;")}
        >
          <TaskCheckBox
            label={"Summon Elite Bosses."}
            param={"summonelitebosses"}
            taskConfig={taskConfig}
            setValue={setValue}
          />
        </div>
        {taskConfig.summonelitebosses && (
          <div style={{ border: "solid 1px;" }}>
            <TaskInput
              label={"Max no of stamina to use for summoning elite bosses"}
              value={taskConfig.useestams}
              onChange={(event) => setValue(event, "useestams")}
            />
          </div>
        )}
        <div
          style={getStyleJSON("background-color: yellow; border: solid 1px;")}
        >
          <TaskCheckBox
            label={"Summon Normal Bosses."}
            param={"summonnormalbosses"}
            taskConfig={taskConfig}
            setValue={setValue}
          />
        </div>
        {taskConfig.summonnormalbosses && (
          <div style={{ border: "solid 1px;" }}>
            <TaskInput
              label={"Max no of stamina to use for summoning normal bosses"}
              value={taskConfig.useestams}
              onChange={(event) => setValue(event, "useestams")}
            />
          </div>
        )}
        {(taskConfig.killelitebosses || taskConfig.summonelitebosses) && (
          <div style={{ border: "solid 1px;" }}>
            <BossSelector
              label={"Select elite boss to kill/summon*"}
              param={"selectedeliteAlliBoss"}
              taskConfig={taskConfig}
              setValue={setValue}
              bosslist={AccountDetailData.allielitebosses}
            />
          </div>
        )}
        {(taskConfig.killnormalbosses || taskConfig.summonnormalbosses) && (
          <div style={{ border: "solid 1px;" }}>
            <BossSelector
              label={"Select normal boss to kill/summon*"}
              param={"selectednormalAlliBoss"}
              taskConfig={taskConfig}
              setValue={setValue}
              isNormalBoss={true}
              bosslist={normalbosses}
            />
          </div>
        )}

        {(taskConfig.summonnormalbosses || taskConfig.summonelitebosses) && (
          <div style={{ border: "solid 1px;" }}>
            <HeroNameSelector
              label={"Select boss summon hero"}
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              param={"defheroname"}
            />
            <TroopMapSelector
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              label={"Add Troops To Send for summoning"}
              param={"troopssummoner"}
            />
          </div>
        )}

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run EBK"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
